export const deliveries = [
  {
    id: 1,
    machine: "CNC Router Machine",
    location: "Riyadh, Saudi Arabia",
    location_ar: "الرياض , السعودية",
    images: [
      "/delivery/1.jpeg",
      "/delivery/2.jpeg",
    ],
  },
  {
    id: 2,
    machine: "Fiber Laser Machine",
    location: "Riyadh, Saudi Arabia",
    location_ar: "الرياض , السعودية",
    images: [
      "/delivery/3.jpg",
      "/delivery/4.jpg",
      "/delivery/5.jpg",
      "/delivery/6.jpg",
    ],
  },
  {
    id: 3,
    machine: "50W Fiber Laser Marking Machine",
    location: "Riyadh, Saudi Arabia",
    location_ar: "الرياض , السعودية",
    images: [
      "/delivery/7.jpg",
      "/delivery/8.jpg",
    ],
  },
  {
    id: 4,
    machine: "Fiber Laser Marking Machine & CO₂ Laser Engraving Machine",
    location: "Riyadh, Saudi Arabia",
    location_ar: "الرياض , السعودية",
    images: [
      "/delivery/9.jpg",
      "/delivery/10.jpg",
      "/delivery/11.jpg",
      "/delivery/12.jpg",
    ],
  },
  {
    id: 5,
    machine: "CNC Router Machine",
    location: "Riyadh, Saudi Arabia",
    location_ar: "الرياض , السعودية",
    images: [
      "/delivery/14.jpg",
      "/delivery/15.jpg",
    ],
  },
  {
    id: 6,
    machine: "Fiber Laser Marking Machine",
    location: "Riyadh, Saudi Arabia",
    location_ar: "الرياض , السعودية",
    images: [
      "/delivery/16.jpg",
      "/delivery/17.jpg",
    ],
  },
  {
    id: 7,
    machine: "4-in-1 3kW Handheld Laser Welding Machine",
    location: "Jaddah, Saudi Arabia",
    location_ar: "جدة , السعودية",
    images: [
      "/delivery/18.jpg",
      "/delivery/19.jpg",
      "/delivery/20.jpg",
      "/delivery/21.jpg",
    ],
  },{
    id: 8,
    machine: "Fiber Laser Cutting Machine",
    location: "Saudi Arabia",
    location_ar: "السعودية",
    images: [
      "/delivery/22.jpg",
      "/delivery/23.jpg",
    ],
  },{
    id: 9,
    machine: "CNC Router Machine",
    location: "Jaddah, Saudi Arabia",
    location_ar: "جدة , السعودية",
    images: [
      "/delivery/24.jpg",
    ],
  },
];